import * as React from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const prevPathnameRef = React.useRef(location.pathname);

    React.useEffect(() => {
        if (prevPathnameRef.current !== location.pathname) {
            window.scrollTo(0, 0);
            prevPathnameRef.current = location.pathname;
        }
    }, [location.pathname]);

    return <>{children}</>;
};

export default ScrollToTop;